import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CommonService } from 'huddyapi'; 
import { AppComponent } from '../app.component';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard  {
  constructor(public commonService: CommonService, public router: Router) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if(CommonService.jwt != null) {
      let route : string = AppComponent.product === 'PROFESSIONAL' ? 'patients' : 'work-queue'; 
      this.router.navigate([route]);
      return false;
    }
    return true;
  }
}
